import styles from './IncompleteModal.module.css';

/**
 * Modal shown when user tries to complete a photo with untagged faces.
 *
 * Offers the option to ignore remaining faces or cancel.
 */
export default function IncompleteModal({
  isOpen,
  pendingFacesCount,
  onCancel,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.card}>
        <h4 className={styles.title}>Incomplete tagging</h4>
        <p className={styles.message}>
          There are still untagged faces ({pendingFacesCount}). Do you want to mark
          them as ignored and complete the photo?
        </p>
        <div className={styles.actions}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.confirmButton} onClick={onConfirm}>
            Continue &amp; ignore
          </button>
        </div>
      </div>
    </div>
  );
}
